import UserProfile from '@/common/models/user/UserProfile';
import API from '@/org-app/api';
import { createDeleteAction, createGetAllAction, createPostAction } from '@/utils/ActionsUtils';

import * as types from './mutation-types';

const actions = {
  getUserSettings: createGetAllAction(
    API.instance.getUserSettings,
    types.UPDATE_USERSETTINGS_LIST,
    'messages.failedToGetUserSettings',
    false,
  ),
  createUserSetting: createPostAction(
    API.instance.postUserSetting,
    types.UPDATE_USERSETTING,
    'messages.failedToCreateUserSetting',
  ),
  deleteUserSetting: createDeleteAction(
    API.instance.deleteUserSetting,
    types.DELETE_USERSETTING,
    'messages.failedToDeleteUserSetting',
  ),
  getUserProfile: async ({ commit }) => {
    const userSettings = await actions.getUserSettings({ commit }, { showLoader: false });
    return UserProfile.fromUserSettings(userSettings.items);
  },
};

export default actions;
